import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../lib/supabase';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft, FiMail, FiPhone, FiClock, FiMapPin, FiExternalLink, FiTrash2, FiEye, FiEyeOff, FiRefreshCw } = FiIcons;

const sourceLabel = (value) => {
  const labels = {
    contact_page_form: 'Σελίδα Επικοινωνίας',
    home_contact_cta: 'Αρχική · Contact CTA',
  };
  return labels[value] || value || 'Άγνωστη πηγή';
};

const ContactFormsTracking = () => {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  const load = async () => {
    setLoading(true);
    setMessage('');
    const { data, error } = await supabase.from('contact_forms_aox1234').select('*').order('created_at', { ascending: false });
    if (error) setMessage(error.message);
    else setItems(data || []);
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const toggleSeen = async (item) => {
    const { error } = await supabase.from('contact_forms_aox1234').update({ is_seen: !item.is_seen, updated_at: new Date().toISOString() }).eq('id', item.id);
    if (!error) setItems((prev) => prev.map((row) => row.id === item.id ? { ...row, is_seen: !row.is_seen } : row));
  };

  const remove = async (item) => {
    if (!window.confirm(`Διαγραφή επικοινωνίας από ${item.name};`)) return;
    const { error } = await supabase.from('contact_forms_aox1234').delete().eq('id', item.id);
    if (!error) setItems((prev) => prev.filter((row) => row.id !== item.id));
  };

  const formatDate = (value) => new Date(value).toLocaleString('el-GR');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="border-b bg-white shadow-sm">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4">
          <div className="flex items-center gap-3"><button onClick={() => navigate('/admin/dashboard')} className="rounded-lg p-2 hover:bg-gray-100"><SafeIcon icon={FiArrowLeft} className="h-5 w-5" /></button><div><h1 className="text-xl font-black">Φόρμες Επικοινωνίας</h1><p className="text-xs text-gray-500">Με tracking πηγής / URL / UTM</p></div></div>
          <button onClick={load} className="flex items-center rounded-lg border px-3 py-2 text-sm font-bold"><SafeIcon icon={FiRefreshCw} className="mr-2 h-4 w-4" />Ανανέωση</button>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-8">
        {message && <div className="mb-5 rounded-xl bg-red-50 p-4 text-red-700">{message}</div>}
        {loading ? <div className="py-16 text-center text-gray-500">Φόρτωση...</div> : items.length === 0 ? <div className="rounded-2xl bg-white py-16 text-center text-gray-500 shadow-sm">Δεν υπάρχουν επικοινωνίες.</div> : (
          <div className="space-y-4">
            {items.map((item) => (
              <div key={item.id} className={`rounded-2xl border bg-white p-5 shadow-sm ${!item.is_seen ? 'border-blue-200 ring-1 ring-blue-100' : 'border-gray-100'}`}>
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div>
                    <div className="flex flex-wrap items-center gap-2"><h2 className="text-lg font-black text-gray-900">{item.name}</h2>{!item.is_seen && <span className="rounded-full bg-blue-100 px-2 py-1 text-xs font-black text-blue-700">ΝΕΟ</span>}<span className="rounded-full bg-gray-100 px-2 py-1 text-xs font-bold text-gray-600">{item.subject || 'other'}</span></div>
                    <div className="mt-3 flex flex-wrap gap-3 text-sm text-gray-600"><a href={`mailto:${item.email}`} className="flex items-center gap-1"><SafeIcon icon={FiMail} className="h-4 w-4" />{item.email}</a><a href={`tel:${item.phone}`} className="flex items-center gap-1"><SafeIcon icon={FiPhone} className="h-4 w-4" />{item.phone}</a><span className="flex items-center gap-1"><SafeIcon icon={FiClock} className="h-4 w-4" />{formatDate(item.created_at)}</span></div>
                  </div>
                  <div className="flex gap-2"><button onClick={() => toggleSeen(item)} className="rounded-lg bg-gray-100 p-2" title={item.is_seen ? 'Μη διαβασμένο' : 'Διαβασμένο'}><SafeIcon icon={item.is_seen ? FiEyeOff : FiEye} className="h-4 w-4" /></button><button onClick={() => remove(item)} className="rounded-lg bg-red-50 p-2 text-red-600"><SafeIcon icon={FiTrash2} className="h-4 w-4" /></button></div>
                </div>

                <div className="mt-5 rounded-xl bg-gray-50 p-4 text-gray-700 whitespace-pre-wrap">{item.message}</div>

                <div className="mt-5 grid gap-3 rounded-xl border border-blue-100 bg-blue-50 p-4 text-sm md:grid-cols-2">
                  <div><span className="font-black text-blue-900">Πηγή:</span> {sourceLabel(item.source_location)}</div>
                  <div><span className="font-black text-blue-900">Referrer:</span> {item.referrer || '—'}</div>
                  <div className="md:col-span-2 break-all"><span className="font-black text-blue-900">Page URL:</span> {item.page_url ? <a href={item.page_url} target="_blank" rel="noopener noreferrer" className="ml-1 underline">{item.page_url} <SafeIcon icon={FiExternalLink} className="inline h-3 w-3" /></a> : '—'}</div>
                  <div><span className="font-black text-blue-900">UTM Source:</span> {item.utm_source || '—'}</div>
                  <div><span className="font-black text-blue-900">UTM Campaign:</span> {item.utm_campaign || '—'}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactFormsTracking;
